<div class="relative flex flex-col w-full h-full">

  <!-- ============================================ -->
  <!-- HEADER - outside the scroll          -->
  <!-- ============================================ -->
  <div class="flex-none border-b border-gray-200">
    <table class="w-full table-fixed">
      <thead>
        <tr class="bg-[#F9FAFB] h-11 xl:h-14 text-gray-500 text-[0.5rem] xl:text-[0.6rem] 2xl:text-[0.7rem]">
          <th class="py-3 pl-[16px] text-left w-[28%]">
            <h2>ATTIVITÀ</h2>
          </th>
          <th class="py-3 text-center w-[5%]">
            <h2>#</h2>
          </th>
          <th class="py-3 pl-[16px] text-left w-[27%]">
            <h2>STAKEHOLDERS</h2>
          </th>
          <th class="py-3 text-center w-[10%]">
            <h2 class="text-green-600">COMPLETATA</h2>
          </th>
          <th class="py-3 text-center w-[10%]">
            <h2 class="text-yellow-600">IN CORSO</h2>
          </th>
          <th class="py-3 text-center w-[10%]">
            <h2 class="text-red-500">IN RITARDO</h2>
          </th>
          <th class="py-3 text-center w-[10%]">
            <h2>NESSUNA DATA</h2>
          </th>
        </tr>
      </thead>
    </table>
  </div>

  <!-- ============================================ -->
  <!-- BODY - scrollable  -->
  <!-- ============================================ -->
  <div class="relative flex-1 overflow-y-auto scrollbar2 min-h-0">

    <!-- No data message -->
    <div *ngIf="!finalList || finalList.length === 0" class="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
      <p class="text-gray-400 font-medium text-[0.7rem] 2xl:text-[0.75rem] 3xl:text-[0.8rem] bg-sky-100 px-4 py-2 rounded-sm">
        Non ci sono dati da mostrare
      </p>
    </div>

    <!-- ============================================ -->
    <!-- PLACEHOLDER TABLE - When NO data exists     -->
    <!-- ============================================ -->
    <table *ngIf="!finalList || finalList.length === 0" class="w-full table-fixed opacity-40">
      <colgroup>
        <col class="w-[28%]" />
        <col class="w-[5%]" />
        <col class="w-[27%]" />
        <col class="w-[10%]" />
        <col class="w-[10%]" />
        <col class="w-[10%]" />
        <col class="w-[10%]" />
      </colgroup>
      <tbody class="text-[0.68rem]">
        <tr *ngFor="let item of placeholderRows" class="border-b border-gray-100 align-middle h-[58px]">
          <td class="px-2 py-2 pl-[16px] text-gray-500"><h5>---</h5></td>
          <td class="px-2 py-2 text-center text-gray-500"><h5>---</h5></td>
          <td class="px-2 py-3 pl-[16px] text-gray-500"><h5>---</h5></td>
          <td class="px-2 py-2 text-center text-gray-500"><h5>---</h5></td>
          <td class="px-2 py-2 text-center text-gray-500"><h5>---</h5></td>
          <td class="px-2 py-2 text-center text-gray-500"><h5>---</h5></td>
          <td class="px-2 py-2 text-center text-gray-500"><h5>---</h5></td>
        </tr>
      </tbody>
    </table>

    <!-- ============================================ -->
    <!-- REAL TABLE - When data exists               -->
    <!-- ============================================ -->
    <table *ngIf="finalList && finalList.length > 0" class="w-full table-fixed">
      <colgroup>
        <col class="w-[28%]" />
        <col class="w-[5%]" />
        <col class="w-[27%]" />
        <col class="w-[10%]" />
        <col class="w-[10%]" />
        <col class="w-[10%]" />
        <col class="w-[10%]" />
      </colgroup>
      <tbody class="text-[0.68rem]">
        <tr *ngFor="let item of finalList" class="border-b border-gray-100 align-middle">
          <td class="px-2 py-2 pl-[16px] text-gray-800 text-[0.52rem] xl:text-[0.62rem] 2xl:text-[0.71rem] break-words whitespace-normal leading-tight">{{ item.activityName }}</td>
          <td class="px-2 py-2 text-center text-[0.52rem] xl:text-[0.62rem] 2xl:text-[0.71rem] text-gray-600 leading-tight">{{ item.totalCount }}</td>
          <td class="px-2 py-3 pl-[16px] leading-tight">
            <div class="flex flex-wrap gap-[5px]">
              <span *ngFor="let s of item.stakeholders" class="inline-block px-2 py-0.5 rounded-full text-[0.52rem] xl:text-[0.62rem] 2xl:text-[0.71rem] bg-gray-100 text-gray-500">
                {{ s }}
              </span>
            </div>
          </td>
          <td class="px-2 py-2 text-center">
            <span class="inline-block px-2 py-0.5 rounded-full font-medium text-green-600 text-[0.52rem] xl:text-[0.62rem] 2xl:text-[0.71rem]">{{ item.completedCount }}</span>
          </td>
          <td class="px-2 py-2 text-center">
            <span class="inline-block px-2 py-0.5 rounded-full font-medium text-yellow-600 text-[0.52rem] xl:text-[0.62rem] 2xl:text-[0.71rem]">{{ item.inProgressCount }}</span>
          </td>
          <td class="px-2 py-2 text-center">
            <span class="inline-block px-2 py-0.5 rounded-full font-medium text-red-500 text-[0.52rem] xl:text-[0.62rem] 2xl:text-[0.71rem]">{{ item.delayedCount }}</span>
          </td>
          <td class="px-2 py-2 text-center">
            <span class="inline-block px-2 py-0.5 rounded-full font-medium text-gray-700 text-[0.52rem] xl:text-[0.62rem] 2xl:text-[0.71rem]">{{ item.noDataCount }}</span>
          </td>
        </tr>
      </tbody>
    </table>

  </div>

</div>